const $ = jQuery;

String.prototype.cucuHashCode = function () {
    let hash = 0;

    if (this.length === 0) {
        return hash;
    }

    for (let i = 0; i < this.length; i++) {
        const char = this.charCodeAt(i);
        hash = ((hash << 5) - hash) + char;
        hash = hash & hash; // Convert to 32bit integer
    }

    return hash;
};


const storageKey = 'cucu_storage' + window.location.href.cucuHashCode();
const defaultCounter = 3600;

if (!window.localStorage) {
    window.localStorage = {};
}

function startTimer(duration, display) {
    let minutes, seconds;
    let timer = duration;

    display = $(display);
    const updateTimerDisplay = () => {
        minutes = parseInt(timer / 60, 10);
        seconds = parseInt(timer % 60, 10);

        minutes = $('<span class="timer-countdown--minutes" />').text(minutes < 10 ? "0" + minutes : minutes);
        seconds = $('<span class="timer-countdown--seconds" />').text(seconds < 10 ? "0" + seconds : seconds);

        display.empty();
        display.append(minutes);
        display.append(seconds);

        if (--timer < 0) {
            timer = duration;
        }

        window.localStorage[storageKey] = timer;
    };

    setInterval(updateTimerDisplay, 1000);
}

const hour = window.localStorage[storageKey] && window.localStorage[storageKey] > 60 ?
    window.localStorage[storageKey] :
    defaultCounter;

$(window).on('cucu-tweaks/start-timer-init', (e, container = 'body') => {
    $('.timer-countdown', container).each(function (i, counter) {
        startTimer(hour, counter);
    });
}).trigger('cucu-tweaks/start-timer-init');



